import { md5 } from 'js-md5';
export function ts_md5_file(file) {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('No file provided'));
      return;
    }

    const reader = new FileReader();
    reader.onload = e => {
      try {
        const arrayBuffer = e.target.result;
        // const wordArray = Array.from(new Uint8Array(arrayBuffer))
        //   ? Array.from(new Uint8Array(arrayBuffer))
        //   : arrayBuffer;
        const md5Hash = md5(arrayBuffer);
        const fileType = getRealFileType(arrayBuffer); // 获取文件的真实类型
        resolve({ md5 : md5Hash, fileType});
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = () => {
      reject(new Error('Failed to read file'));
    };

    reader.readAsArrayBuffer(file);
  });
}
function getRealFileType(arrayBuffer) {
  const uint8Array = new Uint8Array(arrayBuffer);
  const header = Array.from(uint8Array.slice(0, 16))
    .map(b => b.toString(16).padStart(2, '0'))
    .join(' ');

  // Check for JPEG
  if (header.startsWith('ff d8 ff')) {
    return 'image/jpeg';
  }

  // Check for PNG
  if (header.startsWith('89 50 4e 47')) {
    return 'image/png';
  }

  // Check for GIF
  if (header.startsWith('47 49 46 38')) {
    return 'image/gif';
  }

  // Check for WebP
  if (header.includes('57 45 42 50')) {
    return 'image/webp';
  }

  // Check for MP4
  if (header.includes('66 74 79 70')) {
    return 'video/mp4';
  }

  // Check for MOV
  if (header.includes('66 74 79 70 71 74 20 20')) {
    // return 'video/quicktime';
    return 'video/MOV';
  }

  // Check for MPEG
  if (header.startsWith('00 00 01 b')) {
    return 'video/mpeg';
  }

  // Check for AVI
  if (header.startsWith('52 49 46 46') && header.includes('41 56 49 20')) {
    // return 'video/x-msvideo';
    return 'video/AVI';
  }

  // Default to octet-stream if unknown
  return 'application/未知';
}

// 根据url获取md5
// export function ts_md5_from_url(url) {
//   return new Promise((resolve, reject) => {
//     if (!url) {
//       reject(new Error('No URL provided'));
//       return;
//     }

//     fetch(url)
//       .then((response) => {
//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }
//         return response.arrayBuffer();
//       })
//       .then((arrayBuffer) => {
//         try {
//           const md5Hash = md5(arrayBuffer);
//           const fileType = getRealFileType(arrayBuffer);
//           resolve({ md5Value: md5Hash, fileType });
//         } catch (error) {
//           reject(error);
//         }
//       })
//       .catch((error) => {
//         reject(new Error(`Failed to fetch or process file: ${error.message}`));
//       });
//   });
// }

